module.exports = __webpack_public_path__ + "img/przelewy2.4ae656b.svg";